import { createContext, useCallback, useContext, ReactNode } from "react";
import { track } from "@/lib/track";

// The old insurance pop-up form has been retired. All "verify insurance"
// CTAs now navigate directly to /verify-insurance.
// This provider is kept as a no-op shim so existing imports keep working.

type Ctx = { open: () => void; close: () => void; isOpen: boolean };
const InsuranceModalContext = createContext<Ctx | null>(null);

export const useInsuranceModal = () => {
  const ctx = useContext(InsuranceModalContext);
  if (!ctx) throw new Error("useInsuranceModal must be used inside InsuranceModalProvider");
  return ctx;
};

export const InsuranceModalProvider = ({ children }: { children: ReactNode }) => {
  const open = useCallback(() => {
    track("insurance_popup_opened", { redirected_to: "/verify-insurance" });
    if (typeof window !== "undefined") {
      window.location.href = "/verify-insurance";
    }
  }, []);
  const close = useCallback(() => {}, []);

  return (
    <InsuranceModalContext.Provider value={{ open, close, isOpen: false }}>
      {children}
    </InsuranceModalContext.Provider>
  );
};
